import * as React from "react";
import { useState, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { SecurityAppSecurityEvents } from "@graylog/enterprise-api";
import SuggestionsList from "components/common/EntityFilters/FilterConfiguration/SuggestionsList";
import usePluginEntities from "hooks/usePluginEntities";
const DEFAULT_SEARCH_PARAMS = {
  query: "",
  pageSize: 10,
  page: 1
};
const EventDefinitionTypeFilter = ({
  attribute,
  allActiveFilters,
  filter,
  filterValueRenderer,
  onSubmit
}) => {
  const [filterQuery, setFilterQuery] = useState(DEFAULT_SEARCH_PARAMS);
  const eventDefinitionTypes = usePluginEntities("eventDefinitionTypes");
  const fetchEventDefinitionTypes = () => SecurityAppSecurityEvents.getFilterOptions({
    fields: ["event_definition_type"],
    timerange: 30 * 86400
  }).then(
    (resp) => resp.event_definition_type.map((entry) => {
      var _a, _b;
      return {
        id: entry,
        value: (_b = (_a = eventDefinitionTypes.find((edt) => edt.type === entry)) == null ? void 0 : _a.displayName) != null ? _b : entry
      };
    })
  );
  const { data: _suggestions, isInitialLoading } = useQuery({
    queryKey: ["security_events", "event_definition_types"],
    queryFn: fetchEventDefinitionTypes
  });
  const suggestions = useMemo(
    () => _suggestions ? [..._suggestions.filter((suggestion) => suggestion.value.toLowerCase().includes(filterQuery.query))] : _suggestions,
    [_suggestions, filterQuery]
  );
  return /* @__PURE__ */ React.createElement(
    SuggestionsList,
    {
      allActiveFilters,
      attribute,
      multiSelect: !filter,
      filterValueRenderer,
      onSubmit,
      suggestions,
      isLoading: isInitialLoading,
      total: suggestions == null ? void 0 : suggestions.length,
      page: 1,
      pageSize: suggestions == null ? void 0 : suggestions.length,
      setSearchParams: setFilterQuery
    }
  );
};
export default EventDefinitionTypeFilter;
